export default {
      id: "filter-desc-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "assets/sprite.svg#filter-desc-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./assets/svg/filter-desc.svg
// module id = ./assets/svg/filter-desc.svg
// module chunks = 0 1 2